export default __webpack_public_path__ + "static/cover-big-sportplus-1ec80b59c272b6df2f2a479517fc5cee.png";